// Lightweight mobile swipe-to-go-back with subtle animation
// Activates on touch devices when swipe starts near left edge

export function initMobileGestures() {
  if (typeof window === 'undefined') return;
  if (!('ontouchstart' in window)) return;
  const appRoot = document.getElementById('root') as HTMLElement;
  if (!appRoot) return;

  let startX = 0;
  let startY = 0;
  let touching = false;

  function onTouchStart(e: TouchEvent) {
    if (e.touches.length !== 1) return;
    const t = e.touches[0];
    if (t.clientX > 30) return; // only edge swipes
    startX = t.clientX;
    startY = t.clientY;
    touching = true;
    appRoot.style.transition = 'none';
  }

  function onTouchMove(e: TouchEvent) {
    if (!touching) return;
    const t = e.touches[0];
    const dx = t.clientX - startX;
    const dy = Math.abs(t.clientY - startY);
    if (dx < 0 || dx < 10 || dy > Math.abs(dx) * 0.6) return; // not a horizontal edge swipe
    appRoot.style.transform = `translateX(${Math.min(dx, window.innerWidth)}px)`;
    appRoot.style.boxShadow = 'rgba(0,0,0,0.08) -6px 0 24px';
  }

  function onTouchEnd() {
    if (!touching) return;
    touching = false;
    const transform = appRoot.style.transform || '';
    const match = transform.match(/translateX\((\d+)px\)/);
    const moved = match ? Number(match[1]) : 0;
    appRoot.style.transition = 'transform 180ms ease-out';
    if (moved > Math.min(120, window.innerWidth * 0.18)) {
      // animate to right then go back
      appRoot.style.transform = `translateX(${window.innerWidth}px)`;
      setTimeout(() => {
        try { history.back(); } catch (_e) { window.location.hash = '/'; }
      }, 180);
    } else {
      // revert
      appRoot.style.transform = '';
      appRoot.style.boxShadow = '';
    }
  }

  window.addEventListener('touchstart', onTouchStart, { passive: true });
  window.addEventListener('touchmove', onTouchMove, { passive: true });
  window.addEventListener('touchend', onTouchEnd, { passive: true });
}
